import React, {useEffect, useState, useRef} from 'react';
import ReactQuill from 'react-quill';
import { Box } from "@chakra-ui/react";
import 'react-quill/dist/quill.bubble.css';
import '../styles/quill.scss'
// import 'react-quill/dist/quill.snow.css';
import { formatQuillContentLinks } from '../../../global/helpers/global-helpers';
// import { useState } from 'react';

export default function LaunchdeckInputTextArea({
  ref,
  name,
  onChangeHandler,
  defaultDelta, 
  placeholder,
  theme,
  showBorder,
  borderColor,
  isFocused,
  isTile
}) {
  const editorRef = useRef(null);
  // const [showFocusBorder, setShowFocusBorder] = useState(false)
  const [displayedBorderColor, setBorderColor] = useState("#CBD5E0")

  
  useEffect(() => {
   if (isFocused) {
      const editor = editorRef.current.getEditor(); // Get Quill instance
      editor.focus(); // Focus on editor immediately 
   } 
  }, [isFocused]);

  useEffect(() => {
    if (borderColor) {
      setBorderColor(borderColor)
    } 
   }, [borderColor]);

  useEffect(() => {
    const editorContainer = document.querySelector(".ql-editor");

    if (!editorContainer) return;
    // Toggle the 'tile' class based on isTile
    if (isTile) {
      editorContainer.classList.add("tile");
    } else {
      editorContainer.classList.remove("tile");
    }
  }, [isTile]); // Runs whenever isTile changes


  useEffect(() => {
    // Replace link in placeholder with your own text
    const linkInput = document.querySelector('.ql-tooltip-editor input');
    if (linkInput) {
      linkInput.setAttribute("data-link", "e.g. https://www.google.com");
    }
  }, []); // Runs once when the component mounts

  // useEffect(() => {
  //   const contentInQuillDelta = convertToQuillDelta(defaultDelta)
  //   setDisplayedContent(contentInQuillDelta)
  // }, [defaultDelta]); // Initialise any non delta format to delta

 
 

  // useEffect(() => {
  //   if (quillRef.current) {
  //     const quill = quillRef.current.getEditor();

  //     quill.getModule("toolbar").addHandler("link", () => {
  //       const value = prompt("Enter a link:");
  //       if (value) {
  //         const fixedLink =
  //           value.startsWith("http://") || value.startsWith("https://")
  //             ? value
  //             : `https://${value}`;
  //         quill.format("link", fixedLink);
  //       }
  //     });
  //   }
  // }, []);


  const handleChangeInputValue = (content, delta, source, editor) => {
    const deltaContent = editor.getContents(); // Get content in Delta format
    const linkFormattedDeltaContent = formatQuillContentLinks(deltaContent)
    onChangeHandler(name, linkFormattedDeltaContent)
  };


   // Defines Toolbar options
    const modules = {
      toolbar: 
      [
        ['bold', 'italic', 'underline', 'strike', 'blockquote','link'],
        [{ header: [1, 2, 3, 4, 5, 6, false] }], 
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{ 'align': [] }],
        ['clean']                                         // remove formatting button
      ]
    };

  return <Box
    ref={ref && ref}
    className="parent-container"
    fontSize='0.875em'
    >
    <ReactQuill
      ref={editorRef}
      name={name && name}
      theme={theme==="snow" ? "snow":"bubble"}
      value={defaultDelta} 
      onChange={handleChangeInputValue}
      modules={modules}
      style={{
        backgroundColor: "#fff", 
        ...(showBorder && {border: `1px solid ${displayedBorderColor}`}), 
        borderRadius: "8px", // Rounded corners
        padding: "0.25em", // Internal padding
        ...(isTile && {minHeight: '10vh'}),
        ...(isTile && {marginTop: '1em'})
      }}
      placeholder={placeholder && placeholder}
    />

  </Box>;
}